import React, { useState } from 'react'
import { keyframes } from 'tss-react'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import { CloseReason } from '@mui/material/SpeedDial/SpeedDial'
import { J2Editacontent } from '@e3dc-react/icons'

export interface FabMenuProps {
  actions: FabMenuAction[]
  ariaLabel: string
  keepTooltipOpen?: boolean
  visible?: boolean
}
export interface FabMenuAction {
  name: string
  icon: React.ReactNode
  callback: () => void
  id: string
  disabled?: boolean
}

const FADE_IN_ANIMATION = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const FabMenu: React.FC<FabMenuProps> = ({ actions, ariaLabel, keepTooltipOpen, visible = true }) => {
  const [open, setOpen] = useState(false)

  const handleClose = (_: unknown, closeReason: CloseReason): void => {
    if (closeReason === 'toggle') {
      return
    }

    setOpen(false)
  }

  const handleOpen = (): void => {
    setOpen(true)
  }

  return (
    <SpeedDial
      sx={{
        position: 'fixed',
        bottom: {
          xs: 56 + 16,
          sm: 16,
        },
        right: 16,
        visibility: visible ? 'visible' : 'hidden',
        ...(visible && {
          animation: `${FADE_IN_ANIMATION} 2s`,
        }),
      }}
      icon={<J2Editacontent />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      ariaLabel={ariaLabel}
    >
      {actions.map(action => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipOpen={keepTooltipOpen}
          tooltipTitle={action.name}
          onClick={action.callback}
          data-qa={`dab-menu-action-${action.id}`}
          FabProps={{ disabled: action.disabled }}
        />
      ))}
    </SpeedDial>
  )
}

export default FabMenu
